import styled from 'styled-components';

export const TabContainer = styled.div`
  border-bottom: 1px solid;
`;

export const Tab = styled.ul`
  display: flex;
  gap: 1rem;
`;

export const TabItemWrapper = styled.li`
  border-bottom: ${({ active }) =>
    active ? '2px solid rgb(75, 40, 109)' : '0'};
  padding-bottom: 0.5rem;
`;

export const TabItem = styled.div`
  padding: 0.75rem 2rem;
  border: ${({ active }) => (active ? '2px solid rgb(75, 40, 109)' : '0')};
  background: ${({ active }) => (active ? '#f5f5f5' : '#fff')};
  color: ${({ active }) => (active ? 'rgb(75, 40, 109)' : '#676767')};
  font-weight: 700;
  font-size: 14px;
  border-radius: 3rem;
  cursor: pointer;

  &:hover {
    box-shadow: ${({ active }) => (active ? '' : 'inset 0 0 0 2px #676767')};
  }
`;
